<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title @click="$router.push({name: 'home'})">Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-face</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title @click="$router.push({name: 'authors'})">Authors</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-book</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Unread</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-book</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Read</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="accent-4" v-if="user.loggedIn" dark dense>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>Story reader</v-toolbar-title>
      <v-btn icon v-if="$route.name !== 'home' && $route.name !== 'login'" @click="$router.go(-1) ">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon @click.prevent="signOut">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-app-bar app color="accent-4" dense dark v-else>
      <v-toolbar-title>Story reader</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
  import firebase from 'firebase';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'App',
    components: {},
    data() {
      return {
       drawer: false
      };
    },
    computed: {
      ...mapGetters({
        user: 'user'
      })
    },
    methods: {
      ...mapActions({
        fetchUser: 'fetchUser'
      }),
      signOut() {
        firebase
          .auth()
          .signOut()
          .then(() => {
            this.fetchUser(null);
            this.$router.replace({
              name: "login"
            });
          });
      }
    }
  };
</script>
